import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mfCustomManageForecastBottlerData: {
    bottler: null,
    bottlerOwnerCode: null,
  },
  mfCustomManageForecastTreeData: [],
  mfCustomManageForecastFinalTreeData: [],
};

const MFCustomManageScreenRedux = createSlice({
  name: "MFCustomManageScreenRedux",
  initialState,
  reducers: {
    setMFCustomManageForecastBottlerData: (state, action) => {
      state.mfCustomManageForecastBottlerData = action.payload;
    },
    setMFCustomManageForecastTreeData: (state, action) => {
      state.mfCustomManageForecastTreeData = action.payload;
    },
    setMFCustomManageForecastFinalTreeData: (state, action) => {
      state.mfCustomManageForecastFinalTreeData = action.payload;
    },
  },
});

export const {
  setMFCustomManageForecastBottlerData,
  setMFCustomManageForecastTreeData,
  setMFCustomManageForecastFinalTreeData,
} = MFCustomManageScreenRedux.actions;
export default MFCustomManageScreenRedux.reducer;
